import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ErrorOutlineOutlined as ErrorIcon } from '@mui/icons-material';

// Compact inline failure + retry for a section inside a larger view (drawer
// tab, card, sidebar) where a full-page ErrorState would be too heavy.
const InlineRetry = ({ message = "Couldn't load this section.", retryLabel = 'Retry', onRetry }) => {
  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: 1.5,
        py: 1.25,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.5,
        bgcolor: 'action.hover',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
        <ErrorIcon color="error" fontSize="small" />
        <Typography variant="body2">{message}</Typography>
      </Stack>
      {onRetry && (
        <Button size="small" onClick={onRetry} sx={{ flexShrink: 0 }}>
          {retryLabel}
        </Button>
      )}
    </Box>
  );
};

export default InlineRetry;
